import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

// 生成班级选项：初一1-14班，初二1-13班，初三1-13班
const generateClassOptions = () => {
  const classes: string[] = [];
  
  // 初一1-14班
  for (let i = 1; i <= 14; i++) {
    classes.push(`初一${i}班`);
  }
  
  // 初二1-13班
  for (let i = 1; i <= 13; i++) {
    classes.push(`初二${i}班`);
  }
  
  // 初三1-13班
  for (let i = 1; i <= 13; i++) {
    classes.push(`初三${i}班`);
  }
  
  return classes;
};

const CLASS_OPTIONS = generateClassOptions();

const Login: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [class_name, setClass_name] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isLogin) {
        await login(email, password);
      } else {
        if (password.length < 8) {
          setError('密码必须至少8位');
          setLoading(false);
          return;
        }
        if (!username.trim()) {
          setError('请输入用户名');
          setLoading(false);
          return;
        }
        if (!class_name.trim()) {
          setError('请输入班级');
          setLoading(false);
          return;
        }
        await register(email, password, username.trim(), class_name.trim());
      }
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.message || '操作失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">北海红色人物数字博物馆</h1>
        <h2 className="login-subtitle">{isLogin ? '登录' : '注册'}</h2>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>邮箱</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="input"
              placeholder="请输入邮箱"
            />
          </div>
          
          <div className="form-group">
            <label>密码</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="input"
              placeholder={isLogin ? "请输入密码" : "请输入密码（至少8位）"}
            />
            {!isLogin && (
              <small className="form-hint">密码必须至少8位</small>
            )}
          </div>

          {!isLogin && (
            <>
              <div className="form-group">
                <label>用户名 *</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className="input"
                  placeholder="请输入用户名"
                  maxLength={100}
                />
                <small className="form-hint">用于显示在作品和弹幕中</small>
              </div>

              <div className="form-group">
                <label>班级 *</label>
                <select
                  value={class_name}
                  onChange={(e) => setClass_name(e.target.value)}
                  required
                  className="input"
                >
                  <option value="">请选择班级</option>
                  {CLASS_OPTIONS.map((className) => (
                    <option key={className} value={className}>
                      {className}
                    </option>
                  ))}
                </select>
                <small className="form-hint">用于作品提交时使用</small>
              </div>
            </>
          )}

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? '处理中...' : isLogin ? '登录' : '注册'}
          </button>
        </form>

        <div className="login-switch">
          <span>
            {isLogin ? '还没有账号？' : '已有账号？'}
            <button
              type="button"
              onClick={() => {
                setIsLogin(!isLogin);
                setError('');
                setUsername('');
                setClass_name('');
              }}
              className="link-button"
            >
              {isLogin ? '立即注册' : '立即登录'}
            </button>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Login;

